var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/ranking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ranking"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.67 14H4C2.9 14 2 14.9 2 16V22H8.67V14Z",
    stroke: "#173D33",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.33 10H10.66C9.55997 10 8.65997 10.9 8.65997 12V22H15.33V12C15.33 10.9 14.44 10 13.33 10Z",
    stroke: "#173D33",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20 17H15.33V22H22V19C22 17.9 21.1 17 20 17Z",
    stroke: "#173D33",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.52 2.07001L13.05 3.13C13.12 3.28 13.31 3.42 13.47 3.44L14.43 3.60001C15.04 3.70001 15.19 4.14999 14.75 4.57999L14 5.32999C13.87 5.45999 13.8 5.69999 13.84 5.86999L14.05 6.79001C14.22 7.52001 13.83 7.80001 13.19 7.42001L12.29 6.89001C12.13 6.79001 11.86 6.79001 11.7 6.89001L10.8 7.42001C10.16 7.80001 9.76998 7.52001 9.93998 6.79001L10.15 5.86999C10.19 5.69999 10.12 5.44999 9.98999 5.32999L9.24999 4.59C8.80999 4.15 8.94999 3.70998 9.56999 3.60998L10.53 3.45001C10.69 3.42001 10.88 3.28001 10.95 3.14001L11.48 2.07999C11.77 1.49999 12.23 1.50001 12.52 2.07001Z",
    stroke: "#173D33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.a47cd925ea90fbd5c8aa084cf8d0a3cf.svg";
export { ForwardRef as ReactComponent };